import deepmerge from "deepmerge";

// Obtener oferta
const oferta = require(`./${_BBVA_MOTOR}.js`).default;
const ofertaNomina = require(`./ofertaNomina.js`).default;

const overwriteMerge = (_, sourceArray) => sourceArray;
export default deepmerge(ofertaNomina, oferta, { arrayMerge: overwriteMerge });
